<template>
    <div class="guanjia">
        <el-popover width="185" trigger="manual" v-model="visible" placement="top-start">
            <div class="popover-content">
                你好呀！需要帮忙吗？
                <i @click="close" style="cursor: pointer;" class="el-icon-close"></i>
            </div>
            <img slot="reference" @click="open" class="guanjia" src="@/images/BackTop.png" alt="">
        </el-popover>


        <guanjiaDia ref="guanjiaDia"></guanjiaDia>
    </div>
</template>
<script>
import guanjiaDia from '@/components/guanjiaDia/guanjiaDia'
export default {
    components: {
        guanjiaDia
    },
    data() {
        return {
            visible: false
        };
    },
    mounted() {
        this.visible = Boolean(localStorage.getItem("guanjiaTip"))
    },
    methods: {
        close() {
            this.visible = false
            localStorage.removeItem('guanjiaTip');
        },
        open() {
            this.$nextTick(() => {
                this.$refs.guanjiaDia.dialogVisible = true
            })
        }
    }
}
</script>


<style lang="less" scoped>
.guanjia {
    height: 40px;
    width: 40px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/guanjia/guanjia.vue